import React, { memo, useState } from 'react'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
// import AddIcon from '@material-ui/icons/Add'
import { useTranslation } from 'react-i18next'
// import { makeStyles } from '@material-ui/styles'
// import { createStyles, Theme } from '@material-ui/core/styles'
import VideoIcon from '@material-ui/icons/SlowMotionVideoOutlined'

import { EArticleActionTypes } from 'models'
import { StoryStateValue } from '../reducer'

const VideoUrlView = (props: any) => {
	const { companyStoryDispatch } = props

	// const classes = useStyles()
	const { t } = useTranslation()
	const [url, setUrl] = useState('')
	const [open, set] = useState(false)
	const [valid, setValid] = useState(false)
	const toggle = () => {
		set(!open)
	}
	const save = () => {
		companyStoryDispatch({
			type: EArticleActionTypes.setFeaturedVideo,
			featuredVideo: url,
		})
	}
	const handleChange = (event: any) => {
		const regex = /^(http:\/\/|https:\/\/)(vimeo\.com|youtu\.be|www\.youtube\.com)\/([\w/]+)([?].*)?$/gim
		const newValid = regex.test(event.target.value)
		setValid(newValid)
		if (newValid) setUrl(event.target.value)
	}

	return (
		<>
			<Button color="secondary" onClick={toggle}>
				<VideoIcon style={{ width: 50, height: 50 }} />
			</Button>
			<Dialog
				open={open}
				onClose={toggle}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					{t('Paste in a Video / Youtube link')}
				</DialogTitle>
				<DialogContent>
					<TextField
						autoFocus
						margin="dense"
						label={t('Video url')}
						type="text"
						fullWidth
						onChange={handleChange}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={toggle} color="default">
						Cancel
					</Button>
					<Button onClick={save} color="primary" disabled={!valid}>
						Save
					</Button>
				</DialogActions>
			</Dialog>
		</>
	)
}

const VideoUrl = memo((props: any) => (
	<StoryStateValue keys={['companyStoryDispatch']}>
		<VideoUrlView {...props} />
	</StoryStateValue>
))

export default memo(VideoUrl)
